import React from "react";
import Scripts from "./Scripts";
import { connect } from "react-redux";
import { deepCopy } from "../../../utils";
import * as storeService from "../addRuleStoreService";
import { RuleExpectedCondition, RuleRelation } from "../../../vars";
import { canEditRuleFields } from "../rulePermissions";

function ScriptTab({ rule, auth }) {

    // const {conditions} = rule;
    const { scripts } = rule;
    const disabled = rule.baseRule === true || !canEditRuleFields(auth);


    // const onAddScriptClick = () => {
    //     storeService.changeRule({
    //         ...rule,
    //         scripts: [...rule.scripts,
    //             {
    //                 script: '',
    //                 order: scripts.length,
    //                 relation: RuleRelation.AND
    //             }],
    //         conditions: [...rule.conditions,
    //             {
    //                 type: RuleExpectedCondition.CONTAINS, 
    //                 order: 0, 
    //                 relation: RuleRelation.AND                    
    //             }]
    //     });
    //     //alert(script);
    //     //alert("1");
    // }

    const onAddScriptClick = () => {
        storeService.changeRule({
            ...rule,
            scripts: [...rule.scripts,
            {
                script: '',
                order: scripts.length,
                relation: RuleRelation.AND,
                conditions: [{
                    type: RuleExpectedCondition.CONTAINS,
                    order: 0,
                    relation: RuleRelation.AND
                }]
            }],

        });
    }


    const sortedScripts = deepCopy(scripts).sort((a, b) => a.order - b.order)

    return (
        <>
            {sortedScripts.map((script, id) =>
                <div key={id} className="addrules-script-block-v2">
                    <Scripts
                        script={script}
                        index={script.order}
                        itemsAmount={sortedScripts.length}
                        rule={rule}
                        disabled={disabled}
                        // Pass Add Script callback only to the last script block
                        onAddScriptClick={id === sortedScripts.length - 1 ? onAddScriptClick : null}
                        addScriptDisabled={disabled}
                    />
                </div>
            )}
        </>
    )

}

function mapStateToProps(state) {
    const addRulesPage = state.addRulesPage;
    const auth = state.auth;
    return {
        rule: addRulesPage.rule,
        auth,
    }
}
export default connect(mapStateToProps)(ScriptTab);
